import proofkitFilemakerService from './proofkitFilemakerService.js';

// Get the layout name from environment variables
const LAYOUT = process.env.REACT_APP_FILEMAKER_LAYOUT_PLAN;

/**
 * Delete a plan item by its record ID
 * @param {string} recordId - The record ID of the plan item to delete
 * @returns {Promise} - The API response
 */
export const deletePlanItem = async (recordId) => {
  try {
    console.log(`Attempting to delete plan item with recordId: ${recordId} from layout: ${LAYOUT}`);
    const response = await proofkitFilemakerService.deleteRecord(LAYOUT, recordId);
    console.log('Delete plan item response:', response);
    return response;
  } catch (error) {
    console.error(`Error deleting plan item with ID ${recordId}:`, error);
    throw error;
  }
};